import * as React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ISerializers, SanityBlockContentLinkProps } from 'components/sanity-block-renderer';

const StyledLink = styled(Link)`
  color: ${Styles.color.black};
`;

export const StyledAnchor = styled.a`
  color: ${Styles.color.black};
`;

export const linkOptions = ({ children = [], mark = {} }: SanityBlockContentLinkProps) => {
  const [linkText] = children;
  const { href } = mark;

  if (!href || !linkText) {
    return null;
  }

  if (href.startsWith('/')) {
    return <StyledLink to={href}>{linkText}</StyledLink>;
  }

  return (
    <StyledAnchor href={href} target="_blank" rel="noopener noreferrer">
      {linkText}
    </StyledAnchor>
  );
};

const linkSerializers: ISerializers = {
  marks: {
    link: linkOptions,
  },
};

export default linkSerializers;
